/* 
    가맹점 조회 매장 테스트 데이터
    1. 매장번호
    2. 매장명
    3. 매장 전화번호
    4. 매장 주소
    5. 매장 개업일
*/

const storeName = ["관저점", "목동점", "둔산점", "탄방점"];
const storeCount = 10; // 생성할 매장 수

// 오늘 날짜를 기준으로 1주일 전의 날짜를 얻는 함수
function getOneWeekAgoDate() {
    const today = new Date();
    const oneWeekAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
    return oneWeekAgo;
}

// 랜덤한 storePhoneNumber를 생성하는 함수
function getRandomPhoneNumber() {
    const prefix = "010";
    const randomSuffix1 = Math.floor(1000 + Math.random() * 9000); // 1000 이상 9999 이하의 랜덤한 숫자 생성
    const randomSuffix2 = Math.floor(1000 + Math.random() * 9000); // 1000 이상 9999 이하의 랜덤한 숫자 생성
    return prefix + randomSuffix1 + randomSuffix2;
}

// 날짜를 'yyyy년 mm월 dd일' 형식으로 변환하는 함수
function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}년 ${month}월 ${day}일`;
}

const testStoreListLocationData = [];

for (let i = 0; i < storeCount; i++) {
    const randomStoreName = storeName[Math.floor(Math.random() * storeName.length)];
    const storeData = {
        storeNo: i + 1, // 매장 번호는 1부터 시작하며 자동 증가
        storeName: randomStoreName,
        storePhoneNumber: getRandomPhoneNumber(),
        storeAddress: `대전광역시 서구 ${randomStoreName} 1114`, // 매장 주소는 '대전광역시 서구' + 매장명 + '1114'로 설정
        storeOpenData: formatDate(new Date(getOneWeekAgoDate().getTime() + Math.random() * (new Date() - getOneWeekAgoDate()))),
        storeFav: false, // 즐겨찾기 상태를 나타내는 필드 추가
    };
    testStoreListLocationData.push(storeData);
}

export default testStoreListLocationData;